import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { KBD } from "../utils/Keybindings";
import { kbdEvent } from "../utils/Utils";
import Cookies from 'js-cookie';


// GET
export function getPickerInputs() {
    const init_values = [10, 12, 16, 18, 24, 36]; 
    const stored = Cookies.get("quantity_input");
    if (!stored) return init_values;

    try {
        const parsed = JSON.parse(stored);
        return Array.isArray(parsed) ? parsed : [...init_values];
    } catch {
        return [...init_values];
    }
}


export function savePickerInput(value) {
    const num = Number(value);

    // only do for two digit inputs..
    if (!Number.isInteger(num) || num < 10 || num > 99) {
        return getPickerInputs();
    }

    let list = getPickerInputs();
    list = list.filter(item => item !== num);
    list.unshift(num);
    list = list.slice(0, 6);

    Cookies.set("quantity_input", JSON.stringify(list), { expires: 365 });

    return list;
}


export default function NumberPicker({ children, onSelect, active = false, offset = [0, 0], showDelete = false, onDelete = () => { } }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const [pos, setPos] = useState({ top: 0, left: 0 });

    function NumberGrid({ pos, onSelect, onMouseEnter, onMouseLeave }) {
        const nums = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        const remembered = getPickerInputs();

        if (!active) {
            return;
        }

        return (
            <div
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                style={{
                    position: "absolute",
                    top: pos.top + offset[0],
                    left: pos.left + offset[1],
                    padding : "8px",
                    background: "var(--text-black)",
                    border: "1px solid var(--border-secondary)",
                    padding: 1,
                    boxShadow: "0 0px 12px rgba(0,0,0,0.7)",
                    zIndex: 999999,


                }}
            >
                <div style={{ gap: 1, display: "grid", gridTemplateColumns: "repeat(3, 25px)" }}>
                    {nums.map((n) => (
                        <div
                            role="button"
                            tabIndex={0}
                            style={n === 0 ? { gridColumn: "1 / -1" } : undefined}
                            className="ui-num-picker-btn"
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    hide();
                                    onSelect(n);
                                }
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                hide();
                                onSelect(n);
                            }}
                        >
                            {n}
                        </div>
                    ))}
                </div>
                {(!showDelete && <div><div className="shim" style={{ "height": "4px" }} /></div>)}
                {(showDelete &&
                    <div style={{ textAlign: "center", background: "var(--text-black)", "padding": "1px 0px" }}>
                        <div
                            role="button"
                            tabIndex={0}
                            style={{ "width": "77px" }}
                            className="ui-num-picker-btn warn"
                            onMouseDown={(e) => {
                                e.preventDefault();
                                hide();
                                onDelete();
                            }}
                        >
                            Delete
                        </div>
                    </div>
                )}

                <div style={{ gap: 1, display: "grid", gridTemplateColumns: "repeat(3, 25px)" }}>
                    {remembered.map((n) => (
                        <div
                            role="button"
                            tabIndex={0}
                            style={n === 0 ? { gridColumn: "1 / -1" } : undefined}
                            className="ui-num-picker-btn"
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    hide();
                                    onSelect(n);
                                }
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                hide();
                                onSelect(n);
                            }}
                        >
                            {n}
                        </div>
                    ))}
                </div>


            </div>
        );
    }

    const show = () => {
        if (!ref.current) return;

        const r = ref.current.getBoundingClientRect();

        setPos({
            top: r.bottom + window.scrollY,
            left: r.left + window.scrollX,
        });

        setVisible(true);
    };

    const hide = () => setVisible(false);

    return (
        <>
            <div
                ref={ref}
                onMouseEnter={show}
                onMouseLeave={hide}
                style={{ display: "inline-block" }}
            >
                {children}
            </div>

            {visible &&
                createPortal(
                    <>
                        <NumberGrid
                            pos={pos}
                            onSelect={(n) => onSelect?.(n)}
                            onMouseEnter={() => setVisible(true)}
                            onMouseLeave={hide}
                        />
                    </>,
                    document.body
                )}
        </>
    );
}